import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 56164312-7555-4017-8A1A-48954BE7F7C5
 * name image-filter-none
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-none.svg
 * tags
 * - Photography 
 */
export const ImageFilterNoneIcon = createSvgIcon(<><path d="M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z" /></>, 'ImageFilterNoneIcon');
export default ImageFilterNoneIcon